import { CourseType, emptyPriceInformation, PriceInformation } from "./paymentTypes";
import create from "zustand";
import defaultPaymentInfoServiceInstance from "../../../provider/paymentInfoService";
import usePaymentCheckoutState from "./paymentCheckoutState";

interface PaymentCheckoutCourseState {

    priceInformation: PriceInformation,
    calculate: () => void;

    course: CourseType,
    setCourse: (course: CourseType) => void;

}

export const usePaymentCheckoutCourseState = create<PaymentCheckoutCourseState>(
    (set, get) => (
        {
            priceInformation: emptyPriceInformation,
            calculate: () => {
                const course = get().course;

                if (!course) {
                    set( {priceInformation: emptyPriceInformation })
                } else {
                    const priceInformation: any =
                        defaultPaymentInfoServiceInstance.calculatePriceForCourse(course, false);

                    set( { priceInformation } );
                }
            },

            course: null,
            setCourse: (course: CourseType) => {
                set( { course } );
                get().calculate();
                usePaymentCheckoutState.getState().recalculatePostData();
            }
        }
    )
);
